<template>
  <v-main >  
    <v-layout text-center >
      <v-container class="containerGallery">
      <div v-if="evidences" class="fullscreen pb-10">
        <div class="m-auto pt-8 pb-12 px-1 px-sm-5" style="max-width:1200px">
          <h1 class="white--text text-center" :style="{'color':theme.backgroundColor + '!important'}">{{$t('Evidences')}}</h1>
          <v-row no-gutters>
            <v-col cols="12" md="6" v-for="(evidence,key) in proofedEvidences" :key="key" >
              <v-row no-gutters>
                <v-col cols="12" class="pa-2">
                  <v-sheet
                    elevation="0"
                    :min-height="(isXsDevice)?300:400"
                    rounded="lg"
                    :style="{'background-color':theme.backgroundColor, 'color':theme.textColor}"
                  >
                  <h2 class="pt-2">{{$t('Evidence')}} {{key+1}}</h2>
                  <EspGallery v-if="evidence.available" 
                  style="text-align:center;max-width:400px;margin:auto;" 
                  fullSize 
                  contain 
                  :images="[evidence.src]" :alias="(key+1)"/>
                  <div v-else>
                    <div class="pa-4" :style="{'margin-top':`${(isXsDevice)?30:90}px`}">{{$t('Evidence_description',{index:key+1})}}</div>
                    <EspButtonPasswordCheckin 
                    :spot="{password:evidence.password}"
                    @success="onSuccess" />
                  </div>
                  </v-sheet>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </div>
      </div>
      </v-container>
    </v-layout>
  </v-main>
</template>

<script>
import {mapGetters} from 'vuex'
import {layoutMixin} from '@/utils/layout-mixin'
import {settingsMixin} from '@/utils/settings-mixin'
import CONFIG from '@/constants/config.js'
import EspGallery from '@/components/ui/EspGallery.vue'
import EspButtonPasswordCheckin from '@/components/spots/EspButtonPasswordCheckin.vue'
export default {
  mixins: [layoutMixin,settingsMixin],
  components:{
    EspGallery,
    EspButtonPasswordCheckin
  },
  data(){
    return {
      evidences:null,
      index: null
    }
  },
  watch: {
    userLanguage: {
      handler() {
        this.loadContent();
      },
      immediate: true
    }
  },
  computed: {
    ...mapGetters('events',['enteredPasswords']),
    proofedEvidences(){
      return (this._.isArray(this.evidences))?this._.map(this.evidences,(evidence)=>{
        let foundEnteredPassword=this._.includes(this.enteredPasswords, evidence.password);
        evidence.available=(evidence && (this._.isEmpty(evidence.password) || foundEnteredPassword));
        return evidence;
      }):null
    }
  },
  methods: {
    onSuccess(password){
      this.addPassword(password);
    },
    addPassword(password){
       this.$store.commit('events/ADD_ENTERED_PASSWORD', password);
    },
    loadContent(){
      const url=`${CONFIG.FEATURE_EVIDENCE.url}_${this.userLanguage}.json`;
      this.axios.get(url).then(response=>{
        if(response){
          this.evidences=response.data;
        }
      })
    }
  }
  
}
</script>

<style scoped>
.containerGallery{

}
.fullscreen{
  position:absolute;
  top:0;
  left:0;
  right:0;
  bottom:0;
  overflow: scroll;
}
</style>
